import { render, staticRenderFns } from "./ComplaintSuggestion.vue?vue&type=template&id=20c1135a&scoped=true"
import script from "./ComplaintSuggestion.vue?vue&type=script&lang=js"
export * from "./ComplaintSuggestion.vue?vue&type=script&lang=js"
import style0 from "./ComplaintSuggestion.vue?vue&type=style&index=0&id=20c1135a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c1135a",
  null
  
)

export default component.exports